<template>
  <span>{{ error }}</span>

  <div :class="fieldControlUi.formField.help">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { fieldControlUi } from '../../base/fieldControlUi'

defineProps<{
  /** Validation message shown first. */
  error: string
}>()

defineSlots<{
  /** Instructions that stay visible while the error is showing. */
  default?: () => unknown
}>()
</script>
